export enum Emotion {
  Happy = 'happy',
  Sad = 'sad',
  Angry = 'angry',
  Think = 'think',
  Surprise = 'surprised',
  Awkward = 'awkward',
  Question = 'question',
  Curious = 'curious',
  Neutral = 'neutral',
}

export const EMOTION_VALUES = Object.values(Emotion)

export const EmotionHappyMotionName = 'Happy'
export const EmotionSadMotionName = 'Sad'
export const EmotionAngryMotionName = 'Angry'
export const EmotionAwkwardMotionName = 'Awkward'
export const EmotionThinkMotionName = 'Think'
export const EmotionSurpriseMotionName = 'Surprise'
export const EmotionQuestionMotionName = 'Question'
export const EmotionNeutralMotionName = 'Idle'
export const EmotionCuriousMotionName = 'Curious'

export const EMOTION_EmotionMotionName_value = {
  [Emotion.Happy]: EmotionHappyMotionName,
  [Emotion.Sad]: EmotionSadMotionName,
  [Emotion.Angry]: EmotionAngryMotionName,
  [Emotion.Think]: EmotionThinkMotionName,
  [Emotion.Surprise]: EmotionSurpriseMotionName,
  [Emotion.Awkward]: EmotionAwkwardMotionName,
  [Emotion.Question]: EmotionQuestionMotionName,
  [Emotion.Neutral]: EmotionNeutralMotionName,
  [Emotion.Curious]: EmotionCuriousMotionName,
}

export const EMOTION_VRMExpressionName_value = {
  [Emotion.Happy]: 'happy',
  [Emotion.Sad]: 'sad',
  [Emotion.Angry]: 'angry',
  [Emotion.Think]: 'think',
  [Emotion.Surprise]: 'surprised',
  [Emotion.Awkward]: undefined,
  [Emotion.Question]: undefined,
  [Emotion.Neutral]: undefined,
  [Emotion.Curious]: 'think',
} satisfies Record<Emotion, string | undefined>

// Live2D expression name mapping (model-specific, defaults for Bunny_Maid)
export const EMOTION_Live2DExpression_value = {
  [Emotion.Happy]: 'Star',
  [Emotion.Sad]: 'Cry',
  [Emotion.Angry]: 'Angry',
  [Emotion.Think]: 'Glasses',
  [Emotion.Surprise]: 'Dizzy',
  [Emotion.Awkward]: 'Blush',
  [Emotion.Question]: 'Dizzy',
  [Emotion.Curious]: 'love',
  [Emotion.Neutral]: undefined,
} satisfies Record<Emotion, string | undefined>

// Live2D expression names that LLM can directly specify (emotion-related)
export const LIVE2D_EXPRESSION_VALUES = [
  'Angry',
  'Black face',
  'Blush',
  'Cry',
  'Dizzy',
  'Glasses',
  'love',
  'Star',
] as const

export type Live2DExpressionName = typeof LIVE2D_EXPRESSION_VALUES[number]

export interface EmotionPayload {
  name: Emotion
  intensity: number
  expression?: string
}
